import { Controller } from "@hotwired/stimulus"
import { OPERATOR, split, includes, without, withReplacedSlot } from "../lib/query_tokens"

// The query text is the single source of truth: rail rows and chips
// only toggle their operator tokens in the input and resubmit (#2994).
export default class extends Controller {
  static targets = ["input", "rail"]

  toggleRail() {
    this.railTarget.classList.toggle("facet-rail--open")
  }

  toggleToken(event) {
    const tokens = split(event.params.token)
    const current = this.#tokens()

    if (tokens.every((token) => includes(current, token))) {
      this.#apply(without(current, tokens))
    } else {
      this.#apply(tokens.reduce((list, token) => withReplacedSlot(list, token), current))
    }
  }

  removeTokens(event) {
    this.#apply(without(this.#tokens(), split(event.params.tokens)))
  }

  clearFilters() {
    this.#apply(this.#tokens().filter((token) => !OPERATOR.test(token)))
  }

  showMore(event) {
    event.target
      .closest("[data-facets-target='group']")
      .classList.add("facet-rail__group--expanded")
  }

  #tokens() {
    return split(this.inputTarget.value)
  }

  #apply(tokens) {
    const value = tokens.join(" ").trim()
    this.inputTarget.value = value
    // The input is required: an emptied query cannot submit, so leave
    // the cleared box focused for the user to type into instead
    if (value === "") {
      this.inputTarget.focus()
      return
    }
    this.inputTarget.form.requestSubmit()
  }
}
